import { Button } from 'aimo-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledWrapper } from 'styles/ContainerStyles';

const ShowMoreButton: React.FC<{ onPress: () => void }> = ({ onPress }) => {
  const { t } = useTranslation();
  return (
    <StyledWrapper center maxWidth={180}>
      <Button
        buttonType={'tertiary'}
        size="l"
        text={t('button.showAll')}
        testID="park-zone-start-park-and-charge-button"
        onPress={onPress}
      />
    </StyledWrapper>
  );
};

export default ShowMoreButton;
